import { LegalDocument, type LegalSectionSpec } from './components/LegalDocument';

const PRIVACY_SECTIONS: LegalSectionSpec[] = [
  { id: 'roles', paragraphs: 2 },
  { id: 'collect', paragraphs: 3 },
  { id: 'sensitive', paragraphs: 2 },
  { id: 'sources', paragraphs: 2 },
  { id: 'purposes', paragraphs: 7 },
  { id: 'bases', paragraphs: 2 },
  { id: 'sharing', paragraphs: 2 },
  { id: 'cookies', paragraphs: 2 },
  { id: 'social', paragraphs: 2 },
  { id: 'googleApi', paragraphs: 1 },
  { id: 'retention', paragraphs: 2 },
  { id: 'security', paragraphs: 2 },
  { id: 'children', paragraphs: 1 },
  { id: 'rights', paragraphs: 4 },
  { id: 'dnt', paragraphs: 1 },
  { id: 'updates', paragraphs: 1 },
  { id: 'contact', paragraphs: 2 },
  { id: 'dsar', paragraphs: 1 },
];

export function PrivacyPage() {
  return <LegalDocument ns="privacy" path="/privacy" sections={PRIVACY_SECTIONS} />;
}
